export default __webpack_public_path__ + "static/media/cascos-microfono.f3143bc0.png";